import { useGetResidenceStatusList } from "@/api/services/global/master";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { Select } from "@/components/elements/Select";
import { YearMonthAmountInput } from "@/features/talent/components/talent-form/YearMonthAmountInput";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { calculateSpecificSkillTransitionPeriod } from "@/features/talent/utils/calculateSpecificSkillTransitionPeriod";
import { black, divider } from "@/theme/colors";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const TalentFormResidenceStatus = () => {
  const methods = useFormContext<TTalentForm>();
  const { control, setValue, trigger } = methods;
  const { residenceStatusOptions } = useGetResidenceStatusList();

  const specifiedSkillFirstStartDate = useWatch({ name: "specifiedSkillFirstStartDate" });
  const blankPeriodMonthly = useWatch({ name: "blankPeriodMonthly" });

  const [componentKey, setComponentKey] = useState(0);

  useEffect(() => {
    if (!specifiedSkillFirstStartDate) {
      setValue("specifiedSkillFirstRemainingTerm", "");
      setValue("specifiedSkillFirstRemainingTermYear", 0);
      setValue("specifiedSkillFirstRemainingTermMonth", 0);
      setComponentKey((prev) => prev + 1);
      return;
    }

    const { monthPeriod, yearPeriod } = calculateSpecificSkillTransitionPeriod({
      specifiedSkillFirstStartDate: specifiedSkillFirstStartDate,
      blankPeriodMonthly: blankPeriodMonthly?.toString() || "0",
    });

    setValue("specifiedSkillFirstRemainingTerm", `${yearPeriod}/${monthPeriod}`);
    setValue("specifiedSkillFirstRemainingTermYear", yearPeriod);
    setValue("specifiedSkillFirstRemainingTermMonth", monthPeriod);

    // Trigger validation
    trigger("specifiedSkillFirstRemainingTerm");

    setComponentKey((prev) => prev + 1);
  }, [specifiedSkillFirstStartDate, blankPeriodMonthly, setValue, trigger]);

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            在留資格情報
          </Typography>
        </Box>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormField control={control} name="residenceStatusId">
              <Select placeholder="選択してください" options={residenceStatusOptions} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="periodOfStay">
              <InputDatePicker placeholder="1990/06/25" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <FormField control={control} name="specifiedSkillFirstStartDate">
              <InputDatePicker placeholder="1990/06/25" />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="blankPeriodMonthly">
              <Input />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="specifiedSkillFirstRemainingTerm">
              <YearMonthAmountInput
                key={componentKey}
                readonly={true}
                isError={false}
                nameYear="specifiedSkillFirstRemainingTermYear"
                nameMonth="specifiedSkillFirstRemainingTermMonth"
              />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormField control={control} name="passportNumber">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="passportExpiryDate">
              <InputDatePicker placeholder="1990/06/25" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
